import { all, put, takeLeading } from 'redux-saga/effects';
import {
  getManageExternalUserSuccessAction,
  getManageExternalUserFailureAction,
  getManageExternalUserAction,
  setUpdateStatusExternalSuccessAction,
  setUpdateStatusExternalFailureAction
} from '../../features/ManageExternalUsers/ManageExternalUsersSlice';
import URLs from '../../../constants/urls';
import {
  GET_MANAGE_EXTERNALUSERS,
  SET_MANAGE_EMPLOYEE_UPDATE_STATUS
} from '../../actions/ManageExternalUsers/ManageExternalUsersActionType';
import { apiPython as api } from '../../../service/api';
import { unwrapApiPayload } from '../../../utils/apiPayload';

export function* getmanagExternaluserCyclesSaga() {
  try {
    const response = yield api.get(URLs.GET_MANAGE_EXTERNALUSERS);
    yield put(getManageExternalUserSuccessAction(unwrapApiPayload(response.data)));
  } catch (error) {
    yield put(getManageExternalUserFailureAction(error));
  }
}

export function* setUpdateStatusListSaga({ payload: body }) {
  try {
    const response = yield api.post(URLs.SET_MANAGE_EMPLOYEE_UPDATE_STATUS, body);
    const updated = response.data;
    yield put(setUpdateStatusExternalSuccessAction(updated));
    if (updated >= 1) {
      yield put(getManageExternalUserAction());
    }
  } catch (error) {
    yield put(
      setUpdateStatusExternalFailureAction(
        error?.response?.data?.message || 'Could not deactivate the selected user(s).'
      )
    );
  }
}

export function* watchmanageEmployeeExternal() {
  yield takeLeading(GET_MANAGE_EXTERNALUSERS, getmanagExternaluserCyclesSaga);
  yield takeLeading(SET_MANAGE_EMPLOYEE_UPDATE_STATUS, setUpdateStatusListSaga);
}

export default function* manageEmployeeExternalSaga() {
  yield all([watchmanageEmployeeExternal()]);
}
